import { router } from './router';
import { NAME } from './constants';
import { apiProvider } from './api';

export const Zapujcky = {
	name: NAME,
	apiProvider,
	router,
};
